import * as defaultImport from "@splunk/visualizations/SingleValueRadial";
export * from "@splunk/visualizations/SingleValueRadial";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
